import { render, staticRenderFns } from "./givePopup.vue?vue&type=template&id=47b6f550&scoped=true"
import script from "./givePopup.vue?vue&type=script&lang=js"
export * from "./givePopup.vue?vue&type=script&lang=js"
import style0 from "./givePopup.vue?vue&type=style&index=0&id=47b6f550&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b6f550",
  null
  
)

export default component.exports